import { Link } from "react-router-dom";
import { useArticles } from "../../../hooks/useArticles";
import { toNewsItems } from "../../../lib/articleAdapter";
import NewsCard from "../../home/components/NewsCard";

export default function LocalNewsGrid() {
  const { articles, loading } = useArticles();
  const localItems = toNewsItems(articles).slice(0, 6);

  return (
    <div>
      {/* Local news */}
      <section className="py-12">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-1 h-7 bg-red-600 rounded-full" />
            <h2 className="text-[#0B1F3A] font-bold" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "1.6rem" }}>
              NOTICIAS LOCALES
            </h2>
          </div>
          <Link to="/actualidad" className="text-blue-600 text-sm font-inter font-medium hover:underline cursor-pointer hidden sm:flex items-center gap-1 whitespace-nowrap">
            Ver todas <i className="ri-arrow-right-line" />
          </Link>
        </div>
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="h-80 bg-slate-200 rounded-2xl animate-pulse" />
            ))}
          </div>
        ) : localItems.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {localItems.map((item) => (
              <NewsCard key={item.id} item={item} variant="default" />
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-2xl border border-slate-100 p-10 text-center">
            <div className="w-14 h-14 flex items-center justify-center bg-slate-100 rounded-full mx-auto mb-4">
              <i className="ri-newspaper-line text-slate-400 text-2xl" />
            </div>
            <p className="text-slate-400 text-sm" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Aún no hay noticias locales publicadas
            </p>
            <p className="text-slate-300 text-xs mt-1" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Se mostrarán automáticamente cuando el admin publique contenido
            </p>
          </div>
        )}
      </section>

      {/* Airport spotlight */}
      <section className="py-12 border-t border-slate-100">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 bg-blue-600 rounded-full" />
          <h2 className="text-[#0B1F3A] font-bold" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "1.6rem" }}>
            AEROPUERTOS DE RD
          </h2>
        </div>
        <div className="bg-[#F4F7FB] rounded-2xl border border-slate-100 p-10 text-center">
          <div className="w-14 h-14 flex items-center justify-center bg-white rounded-full mx-auto mb-4">
            <i className="ri-building-line text-slate-400 text-2xl" />
          </div>
          <p className="text-slate-400 text-sm" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            Próximamente información de aeropuertos
          </p>
          <p className="text-slate-300 text-xs mt-1" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            Se mostrará automáticamente al publicarse desde el admin
          </p>
        </div>
      </section>
    </div>
  );
}